module.exports = __webpack_public_path__ + "media/images/page/lp-sample_large5-530ea3f3ca58a6bb216415857471d31f.jpg";